import Vue from 'vue';
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import Oruga from '@oruga-ui/oruga';

export const OrugaConfig = {
	iconPack: 'fas'
}

if (typeof window.Vue === 'undefined') {
	Vue.use(Oruga, OrugaConfig);
}

// set vars
document.documentElement.style.setProperty(
	'--oruga-variant-primary', process.env.VUE_APP_PRIMARY_COLOR as string);
document.documentElement.style.setProperty(
	'--oruga-pagination-link-current-background-color', process.env.VUE_APP_PRIMARY_COLOR as string);
document.documentElement.style.setProperty(
	'--oruga-pagination-link-current-border-color', process.env.VUE_APP_PRIMARY_COLOR as string);
document.documentElement.style.setProperty(
	'--oruga-datepicker-item-selected-background-color', process.env.VUE_APP_PRIMARY_COLOR as string);
document.documentElement.style.setProperty('--oruga-base-font-size', '1em');
document.documentElement.style.setProperty('--oruga-field-label-font-size', '1em');
document.documentElement.style.setProperty('--oruga-select-font-size', '1em');
document.documentElement.style.setProperty('--oruga-button-font-size', '1em');
document.documentElement.style.setProperty('--oruga-pagination-font-size', '1em');
document.documentElement.style.setProperty('--oruga-checkbox-size', '1em');
  